import React from 'react'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import styled from 'styled-components'
import Page from '../ContentPage'
import LevelSelector from '../LevelSelector'
import Login from '../Login'
const Layout = () => {
  return (
    <Router>
      <PageWrapper id='content-page'>
        <Switch>
          <Route path='/' exact>
            <Login />
          </Route>
          <Route path='/menu' exact>
            <LevelSelector />
          </Route>
          <Route path='/:levelID/:pageID' exact>
            <Page />
          </Route>
        </Switch>
      </PageWrapper>
    </Router>
  )
}

const PageWrapper = styled.div`
    height: 100%;
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);  
    width: 100vw;
    width: calc(var(--vw, 1vw) * 100);  
    display: flex;
    flex-direction: column;
`

export default Layout
